
import { RichText } from '@wordpress/block-editor';
import BlockContext from "../context/blockContext";
import SectionItemContext from "../context/sectionItemContext";
import { useContext } from "@wordpress/element";
const Education = () => {
    const { updateField } = useContext(BlockContext);
    const { item, index, itemIndex } = useContext(SectionItemContext);
    return (
    <div className="cv-education">
    {
        (item.name || item.degree || item.institution || item.city || item.country || item.educationDescription || item.fromDate || item.toDate) && (
            <div className="education-content-wrap">
            <>
                <RichText
                tagName="span"
                className="study-field"
                value={item.name}
                onChange={(value) => updateField(index, "name", value, itemIndex)}
                />
                {item.degree && " | "}
            </>
            <RichText
                tagName="span"
                className="degree-name"
                value={item.degree}
                onChange={(value) => updateField(index, "degree", value, itemIndex)}
            />
            <div className="institution-wrapper">
                <>
                <RichText
                    tagName="span"
                    className="institution"
                    value={item.institution}
                    onChange={(value) => updateField(index, "institution", value, itemIndex)}
                />
                {item.institution && ", "}
                <RichText
                    tagName="span"
                    className="city-country"
                    value={item.city}
                    onChange={(value) => updateField(index, "city", value, itemIndex)}
                />
                {item.city && ", "}
                </>
                <RichText
                tagName="span"
                className="city-country"
                value={item.country}
                onChange={(value) => updateField(index, "country", value, itemIndex)}
                />
            </div>
            <RichText
                className="description"
                value={item.educationDescription}
                onChange={(value) => updateField(index, "educationDescription", value, itemIndex)}
            />
            <div className="duration">
                {item.fromDate ? new Date(item.fromDate).getFullYear() : ""}
                {(item.toDate || item.current) ? ` - ${item.current ? "Present" : new Date(item.toDate).getFullYear()}` : ""}
            </div>
            </div>
        )
    }
    </div>
  )
}

export default Education
